import React, { useMemo, Fragment } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { pathOr } from 'ramda'
import moment from 'moment'

import PopUp from '../../../PopupRedesign'

import styles from './AppartmentOptionDetails.module.scss'

const cx = classNames.bind(styles)

const AppartmentOptionDetails = function ({data}) {
  const {
    amenityName,
    rates,
    salesConditionsOfRate,
    taxesAndFees,
    description,
    currency_symbol,
  } = data;

  const isIncludedTaxesExist = useMemo(function () {
    const data = pathOr([], ['items', 'included', 'items'], taxesAndFees)
    return !!data.length
  }, [taxesAndFees])

  const isNotIncludedTaxesExist = useMemo(function () {
    const data = pathOr([], ['items', 'notIncluded', 'items'], taxesAndFees)
    return !!data.length
  }, [taxesAndFees])

  const isSalesConditionsOfRateExist = useMemo(function () {
    const data = pathOr([], ['description'], salesConditionsOfRate)
    return !!data.length
  }, [salesConditionsOfRate])

  const isRatesExist = useMemo(function () {
    const data = pathOr([], ['items'], rates)
    return !!data.length
  }, [rates])

  const totalRatesPrice = useMemo(function () {
    return isRatesExist ? rates.items.reduce(
      (reducer, item) => (reducer + item.pricing),
      0
    ) : null
  }, [isRatesExist, rates])

  const ratesItems = useMemo(function () {
    return isRatesExist ? rates.items.map(function (rate) {
      return Object.assign({}, rate, {
        dateOut: moment(rate.dateIn).add(rate.nights, 'days').format('YYYY-MM-DD')
      })
    }) : []
  }, [isRatesExist, rates])

  return (
    <PopUp theme="mobile-full">
      <div className={cx('modal-root')}>
        <div className={cx('head')}>
          <h2 className={cx('title')}>{amenityName}</h2>
          { description && (
            <p className={cx('description')}>{description}</p>
          ) }
        </div>
        {
          isRatesExist && (
            <div className={cx('section')}>
              <h3 className={cx('heading')}>{ rates.label}</h3>
              <table className={cx('price-details')}>
                <tbody>
                <tr><th>{amenityName}</th><th>{totalRatesPrice}{currency_symbol}</th></tr>
                { ratesItems.map((el, i) => (
                  <tr key={'price:' + i}><td>{el.dateIn} - {el.dateOut}</td><td>{el.pricing}{currency_symbol}</td></tr>
                )) }
                </tbody>
              </table>
            </div>
          )
        }
        {
          (isIncludedTaxesExist || isNotIncludedTaxesExist) && (
            <div className={cx('section')}>
              <h3 className={cx('heading')}>{ taxesAndFees.label }</h3>
              <dl className={cx('taxes-details')}>
                { isIncludedTaxesExist && (
                  <>
                    <dt>{taxesAndFees.items.included.label}</dt>
                    {taxesAndFees.items.included.items.map((el, i) => (<dd key={'included:'+ i}>{el}</dd>))}
                  </>
                ) }
                { isNotIncludedTaxesExist && (
                  <>
                    <dt>{taxesAndFees.items.notIncluded.label}</dt>
                    {taxesAndFees.items.notIncluded.items.map((el, i) => (<dd key={'notIncluded:' + i}>{el}</dd>))}
                  </>
                ) }
              </dl>
            </div>
          )
        }
        {
          isSalesConditionsOfRateExist && (
            <div className={cx('section')}>
              <h3 className={cx('heading')}>{ salesConditionsOfRate.label }</h3>
              { salesConditionsOfRate.description.map((el, i) => (
                <p key={'salesDescription' + i}>{el}</p>
              )) }
            </div>
          )
        }
      </div>
    </PopUp>
  )
}

AppartmentOptionDetails.propTypes = {
  data: PropTypes.shape({
    amenityName: PropTypes.string.isRequired,
    salesConditionsOfRate: PropTypes.arrayOf({
      label: PropTypes.string.isRequired,
      description: PropTypes.arrayOf(PropTypes.string).isRequired
    }),
    taxesAndFees: PropTypes.any,
    rates: PropTypes.any,
    description: PropTypes.string,
    currency_symbol: PropTypes.string.isRequired,
  }).isRequired
}

export default AppartmentOptionDetails
